module.exports = __webpack_public_path__ + "static/media/rightArrow.92d69b42.svg";